module.exports = {
    extends: [
        '/',
        'templates',
        'core',
        'form',
        'propertiesForm',
    ],

    config: {
        projectMeta: {}, // @see MARK: CUSTOMER_PROJECT_META_LOADER
        contextClass: '',
        baseContextClass: '',
        entityContext: 'projects',
        preventClearOnCancel: true,
        updateTabTitleForFieldCodes: {
            title: true
        },
        updateTabTitleTabContentLocator: '<< base_tabStrip_tabContent',
        grantedMinorChangesForFieldCodes: {},
        heartbeatRefreshOn: {
            'reconnect': true,
            'resourceChanged.bo_projects': true,
        },
    },

    methods: {
        onPrepareDone(storage, isServer){
            if(!isServer){
                const projectStatus = ((this.resourceData.data || {}).attributes || {}).status
                if(projectStatus !== undefined){
                    if(!this.config.baseContextClass){
                        this.config.baseContextClass = String(this.config.contextClass || '')
                    }
                    this.config.contextClass = `${this.config.baseContextClass} projectStatus_${projectStatus}`
                }
            }
        },

        // which properties is a customer allowed to change?
        onProjectMetaChanged(meta, nextMeta){
            if(
                this.config.isReady
                &&
                (!meta.hash || meta.hash !== nextMeta.hash)
            ){
                const grantedChanges = (nextMeta.grantedChanges || {}).project || {}
                if(!grantedChanges.major){
                    this.resetDirties()
                }
                this.refresh(!grantedChanges.major)
            }
        },

        // which properties is a customer allowed to change?
        onBeforeRender(){
            if(!this.config.creationMode){
                const grantedChanges = ((this.model.projectMeta || {}).grantedChanges || {}).project || {}

                for(const fieldCode in this.model.namedFields){
                    const field = this.model.namedFields[fieldCode] || {}
                    field.config = field.config || {}

                    if(field.config.disabledBackup === undefined && field.config.disabled !== undefined){
                        field.config.disabledBackup = !!field.config.disabled
                    }

                    if(grantedChanges.major || grantedChanges.minor && this.config.grantedMinorChangesForFieldCodes[fieldCode]){
                        field.config.disabled = !!field.config.disabledBackup
                    } else {
                        field.config.disabled = true
                    }
                }
            }
        },
    },

    hooks: {
        // which properties is a customer allowed to change?
        projectMetaChanged($element, options){
            const meta = { ...(this.model.projectMeta || {}) }
            const nextMeta = this.model.projectMeta = (options || {}).projectMeta || {}
            this.onProjectMetaChanged(meta, nextMeta)
        },
    },
}